export default __webpack_public_path__ + "static/user2-bc228f60bc9f01ad3ab903cc535e4eec.png";